import React from 'react'

interface BrandFormData {
  name: string
  image?: string
  logo?: string
  description?: string
  website?: string
  contact?: string
  priority?: number
  facebook?: string
  instagram?: string
  youtube?: string
}

interface BrandFormFieldsProps {
  formData: BrandFormData
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
}

const BrandFormFields: React.FC<BrandFormFieldsProps> = ({ formData, onChange }) => {
  return (
    <>
      <div className='form-group mb-3'>
        <label htmlFor='name'>Nazwa marki*</label>
        <input
          type='text'
          className='form-control'
          id='name'
          name='name'
          value={formData.name}
          onChange={onChange}
          required
        />
      </div>

      <div className='form-group mb-3'>
        <label htmlFor='description'>Opis marki</label>
        <textarea
          className='form-control'
          id='description'
          name='description'
          rows={4}
          value={formData.description}
          onChange={onChange}
        />
      </div>

      <div className='form-group mb-3'>
        <label htmlFor='image'>URL obrazka</label>
        <input
          type='url'
          className='form-control'
          id='image'
          name='image'
          value={formData.image}
          onChange={onChange}
          placeholder='https://example.com/image.jpg'
        />
        {formData.image && (
          <div className='mt-2'>
            <img
              src={formData.image}
              alt='Podgląd obrazu'
              className='img-thumbnail'
              style={{ maxHeight: '150px' }}
            />
          </div>
        )}
      </div>

      <div className='form-group mb-3'>
        <label htmlFor='website'>Strona internetowa</label>
        <input
          type='url'
          className='form-control'
          id='website'
          name='website'
          value={formData.website}
          onChange={onChange}
          placeholder='https://example.com'
        />
      </div>

      <div className='form-group mb-3'>
        <label htmlFor='contact'>Kontakt</label>
        <input
          type='text'
          className='form-control'
          id='contact'
          name='contact'
          value={formData.contact}
          onChange={onChange}
          placeholder='Email lub telefon kontaktowy'
        />
      </div>

      <div className='form-group mb-3'>
        <label htmlFor='facebook'>Facebook</label>
        <input
          type='url'
          className='form-control'
          id='facebook'
          name='facebook'
          value={formData.facebook}
          onChange={onChange}
          placeholder='https://facebook.com/twoja-strona'
        />
      </div>

      <div className='form-group mb-3'>
        <label htmlFor='instagram'>Instagram</label>
        <input
          type='url'
          className='form-control'
          id='instagram'
          name='instagram'
          value={formData.instagram}
          onChange={onChange}
          placeholder='https://instagram.com/twoja-strona'
        />
      </div>

      <div className='form-group mb-3'>
        <label htmlFor='youtube'>YouTube</label>
        <input
          type='url'
          className='form-control'
          id='youtube'
          name='youtube'
          value={formData.youtube}
          onChange={onChange}
          placeholder='https://youtube.com/twoj-kanal'
        />
      </div>
      <div className='form-group mb-3'>
        <label htmlFor='priority'>Priorytet</label>
        <input
          type='number'
          className='form-control'
          id='priority'
          name='priority'
          value={formData.priority}
          onChange={onChange}
        />
      </div>
    </>
  )
}

export default BrandFormFields
